"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBillingChargeTypeDescription = void 0;
const BillingChargeTypesDescriptionMap = {
    FULFILLMENT_FEE: "Fulfillment Fees",
    STORAGE_FEES_DTC: "Storage Fees - DTC",
    REMOVAL_FEES: "Removal Fees",
    INBOUND_LABEL_FEES: "Inbound Label Fees",
    CROSSDOCK_FEES: "Crossdock Fees",
    CREDIT_NOTES: "Credit Notes",
    RS_STORAGE_FEE: "Reserve Storage - Monthly Recurring Storage",
    RS_INBOUND_FEE: "Reserve Storage - Inbounding Handling",
    RS_OUTBOUND_FEE: "Reserve Storage - Outbound Handling",
    RS_INBOUND_FLOOR_LOADED_20_FEE: "Reserve Storage - 20'' Floor Loaded Container Unloading",
    RS_INBOUND_PALLETIZED_FEE: "Reserve Storage - Inbounding Handling (Palletized)",
    RS_INBOUND_FLOOR_LOADED_40_FEE: "Reserve Storage - 40'' Floor Loaded Container Unloading",
    RS_RECEIPT_STORAGE_FEE: "Reserve Storage - Receipt Storage",
    RS_CARTON_HANDLING_FEE: "Reserve Storage - Outbound Handling: Carton",
    RS_FTL_PROCESSING_FEE: "Reserve Storage - Freight Processing Fees",
    RS_PALLET_HANDLING_FEE: "Reserve Storage - Outbound Handling: Pallet",
    RS_LTL_PROCESSING_FEE: "Reserve Storage - Freight Processing Fees",
    RS_PARCEL_PROCESSING_FEE: "Reserve Storage - Parcel Processing Fees",
    RS_LABEL_FEE: "Reserve Storage - Labeling",
    RS_STRETCH_WRAP_FEE: "Reserve Storage - Stretch Wrapping Fees",
    RS_GRADE_B_PALLET_FEE: "Reserve Storage - Supplied Grade B Pallets",
    RS_BOL_FEE: "Reserve Storage - BOL Fees",
    RS_SPECIAL_PROJECT_FEE: "Reserve Storage - Special Project Fee",
    RS_LTS_STORAGE_FEE: "Reserve Storage - Long Term Storage Fee (12+ months pallet age)",
    RS_NON_COMPLIANCE_FEE: "Reserve Storage - Non Compliance Fees",
    RS_LTS_12_MONTH_FEE: "Reserve Storage - Long Term Storage Fee (12+ months pallet age)",
    NON_COMPLIANCE_FEE: "Non-Compliance Fee",
    RS_EACH_PICK_OUTBOUND_HANDLING_FEE: "Reserve Storage - Outbound Handling: Each pick",
    RS_B2B_PARCEL_FEE: "Reserve Storage - Parcel Charges",
    PREP_SKU_LABELS_RS: "Charge for SKU LABELLING Prep for RS transfers",
    PREP_BAGGING_PROTECTION_RS: "Charge for Bagging Protection Prep for RS transfers",
    PREP_DAMAGE_PROTECTION_RS: "Charge for Bagging Protection Prep for RS transfers",
    PREP_B2B_UNIT: "Charge for Unit Prep for Wholesale orders",
    PACKING_SLIPS: "Packing Slips",
    PEAK_FULFILLMENT_SURCHARGE: "Peak Fulfillment Surcharge",
    MISSING_BARCODE: "Missing Barcode",
    ILLEGIBLE_LOT: "Illegible Lot",
    ILLEGIBLE_EXPIRATION: "Illegible Expiration",
    MISSING_CONTAINER_LABEL: "Missing Container Label",
    UNKNOWN_BARCODE: "Unknown Barcode",
    PAYPAL_PROCESSING_FEE: "PayPal Processing Fee",
};
function getBillingChargeTypeDescription(chargeType) {
    return (BillingChargeTypesDescriptionMap[chargeType] ??
        chargeType
            .replace(/_/g, " ")
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase()));
}
exports.getBillingChargeTypeDescription = getBillingChargeTypeDescription;
//# sourceMappingURL=Charges.js.map